module.exports = __webpack_public_path__ + "img/credit-one-club-gal-14.d9b012f9.jpg";